import '../../less/sortArrow.less'
import imgAsc from '../../images/arrow-asc.png'
import imgDesc from '../../images/arrow-desc.png'


import React, { Component } from 'react'

class SortArrow extends Component {
    render () {
        const arrowImg = this.props.isReverse
            ? imgAsc
            : imgDesc

        return (
            <img src={ arrowImg } className="arrow-img"/>
        )
    }
}

export default SortArrow



/** WEBPACK FOOTER **
 ** ./src/components/common/SortArrow.js
 **/